import { Input } from '@angular/core';

export abstract class BotaoRedeSocialComponent {

  protected abstract backgroundColor: string;
  protected abstract icon: string;
  protected abstract label: string;
  @Input() link: string;

  constructor() {

  }

  protected abstract abrirRedeSocial();

}


// WEBPACK FOOTER //
// ./src/components/botao-rede-social/botao-rede-social.ts